"use client";

import { useState, useEffect } from 'react';
import { useTranslations } from '@/app/hooks/useTranslations';
import dynamic from 'next/dynamic';

// This component will only be rendered on the client side
function LanguageSelectorComponent() {
  const { currentLanguage, changeLanguage, languages } = useTranslations();
  const [isOpen, setIsOpen] = useState(false);

  // Find current language - fallback to first language if not found
  const displayLanguage = languages.find(lang => lang.code === currentLanguage) || languages[0];

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 text-gray-600 hover:text-primary-500 font-medium transition-colors"
      >
        <span>{displayLanguage.name}</span>
        <svg
          className={`h-4 w-4 transform transition-transform ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 z-10">
          {languages.map((language) => (
            <button
              key={language.code}
              onClick={() => {
                changeLanguage(language.code);
                setIsOpen(false);
              }}
              className={`block w-full px-4 py-2 text-left text-sm ${
                language.code === currentLanguage
                  ? 'bg-gray-100 text-gray-900'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              {language.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

// Export a version that only renders on client-side
// This is the most reliable way to prevent hydration errors in Next.js
export default dynamic(() => Promise.resolve(LanguageSelectorComponent), {
  ssr: false, // Never render on server
  loading: () => <div className="h-8 w-20"></div> // Placeholder during loading
});